import { render, staticRenderFns } from "./QuestionWritingContent.vue?vue&type=template&id=8b98f53e"
import script from "./QuestionWritingContent.vue?vue&type=script&lang=js"
export * from "./QuestionWritingContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports